'use client';

import { useEffect } from 'react';

import Button from '@gds/Button/Button';

export default function ErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // Log the error to sentry
    console.error(error);
  }, [error]);

  return (
    <div>
      <meta name="robots" content="noindex" />
      <h2>Something went wrong!</h2>
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
